import React from 'react';

const periods = [
  { value: 'today', label: 'Oggi' },
  { value: 'yesterday', label: 'Ieri' },
  { value: 'dayBeforeYesterday', label: "L'altro ieri" },
  { value: 'week', label: 'Settimana' },
  { value: 'month', label: 'Mese' },
];

const Tabs = ({ 
  selectedPeriod, 
  selectedCategoria, 
  selectedMandante,
  categorie,
  mandanti,
  onPeriodChange,
  onCategoriaChange,
  onMandanteChange
}) => {
  const hasActiveFilters = selectedCategoria !== 'all' || selectedMandante !== 'all';

  return (
    <>
      <div className="filters-bar">
        <div className="period-pills">
          {periods.map(p => (
            <button
              key={p.value}
              className={`period-pill ${selectedPeriod === p.value ? 'active' : ''}`}
              onClick={() => onPeriodChange(p.value)}
            >
              {p.label}
            </button>
          ))}
        </div>
        <div className="filters-row" style={{ marginTop: '0.5rem' }}>
          <select
            className="filter-select"
            value={selectedCategoria}
            onChange={(e) => onCategoriaChange(e.target.value)}
            aria-label="Filtra per categoria"
          >
            <option value="all">Tutte le categorie</option>
            {categorie.map(c => (
              <option key={c} value={c}>{c}</option>
            ))}
          </select>
          <select
            className="filter-select"
            value={selectedMandante}
            onChange={(e) => onMandanteChange(e.target.value)}
            aria-label="Filtra per mandante"
          >
            <option value="all">Tutti</option>
            {mandanti.map(m => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </div>
      </div>
      {hasActiveFilters && (
        <div className="active-filters">
          {selectedCategoria !== 'all' && (
            <span className="filter-chip">
              {selectedCategoria}
              <button className="filter-chip-remove" onClick={() => onCategoriaChange('all')} aria-label="Rimuovi filtro categoria">×</button>
            </span>
          )}
          {selectedMandante !== 'all' && (
            <span className="filter-chip">
              {selectedMandante}
              <button className="filter-chip-remove" onClick={() => onMandanteChange('all')} aria-label="Rimuovi filtro mandante">×</button>
            </span>
          )}
        </div>
      )}
    </>
  );
};

export default Tabs;
